import type { HeaderItemPosition } from '../sideBar/SideNavHeader';
import type { FC, JSX } from 'react';
import type { RuleSet } from 'styled-components';

import { useRouter } from 'next/compat/router';
import { Fragment } from 'react';
import styled, { css } from 'styled-components';

import { FesLink } from '../../core/link/FesLink';
import { media } from '../../core/styles';
import { useStaticContext } from '~/utilities/context/static/StaticContext';
import { SiteType } from '~/utilities/graphql/codegen';

interface LogoProps {
  logoPosition?: HeaderItemPosition;
}

const style = {
  OutletLogo: css``,
  EmployeeShopLogoDark: css``,
  GStarLogoDark: css``,
  AafLogo: css`
    @media ${({ theme }) => media(theme).lessThan('sm')} {
      max-width: 160px;
    }
  `,
  WahtsLogoDark: css`
    @media ${({ theme }) => media(theme).greaterThan('sm')} {
      background-size: auto 52px;
    }

    @media ${({ theme }) => media(theme).greaterThan('md')} {
      background-size: auto 68px;
    }
  `,
};

const LogoIcon: Record<SiteType, RuleSet<object>> = {
  [SiteType.Gstar]: style.GStarLogoDark,
  [SiteType.Wahts]: style.WahtsLogoDark,
  [SiteType.Outlet]: style.OutletLogo,
  [SiteType.Employeeshop]: style.EmployeeShopLogoDark,
  [SiteType.Aaf]: style.AafLogo,
};

const S = {
  Logo: styled(FesLink)`
    margin: 0 auto;
    position: relative;
    min-width: 140px;
    max-width: 188px;
    display: block;
    font-size: 0;
    height: inherit;
    opacity: 1;
    transition: opacity 0.5s ease-out 0s;
    cursor: pointer;
    background-position: center;
    background-repeat: no-repeat;
    background-image: var(--brand-logo);
    background-size: ${({ theme }) => theme.variables.logo.size};

    ${({ theme }) => LogoIcon[theme.siteType]}

    @media (prefers-reduced-motion) {
      transition: none;
    }
  `,
};

export const Logo: FC<LogoProps & JSX.IntrinsicElements['a']> = ({
  logoPosition = 'main-header',
  ...rest
}) => {
  const router = useRouter();
  const asPath = router?.asPath ?? '';
  const { accessibilityLabels } = useStaticContext();

  const [path] = asPath.split(/[?#]/);
  const isHomePage = path === '/';
  const label = accessibilityLabels?.homepage ?? '';
  const Tag = isHomePage && logoPosition === 'main-header' ? 'h1' : Fragment;

  return (
    <S.Logo {...rest} href="/" data-testid="site-logo">
      <Tag>{label}</Tag>
    </S.Logo>
  );
};
